function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4025 18.6998L20.7803 19.9023L21.7162 21.9127L24.2327 22.4764L24.8982 24.5056L27.9347 24.919L28.0803 22.3637L29.4113 21.086L28.309 18.2488L25.6053 19.1319L22.4025 18.6998Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeWidth: 1.23512,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5611 17.61L34.5492 10.8083L34.2788 11.5411L33.9668 4.7206C33.946 4.47634 34.0916 4.25087 34.3204 4.15692L41.9947 1.03792C42.4939 0.831235 42.8682 1.52643 42.3691 1.7519L34.8611 5.15275L35.2147 4.58907L36.3793 11.3344C36.4209 11.6162 36.317 11.8793 36.109 12.0672L29.121 18.8689C28.2267 19.7707 26.6668 18.4743 27.6027 17.5912L27.5611 17.61Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.7682 24.3553C28.7682 24.3553 33.9884 30.7624 34.0092 30.8C34.1756 30.9879 34.2172 31.2321 34.1756 31.4576L33.0941 36.5119L32.8861 35.9482L37.0457 40.4576C37.3368 40.7582 36.8377 41.1904 36.5257 40.9086L31.7839 36.8877C31.5967 36.7374 31.5551 36.5119 31.5759 36.3052L32.1166 31.1946L32.3038 31.8898L27.0836 25.4826C26.2933 24.4868 27.9363 23.3783 28.7682 24.3741V24.3553Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.948 20.8614L12.4635 17.322L13.2413 17.3957L8.27965 18.3359C8.00634 18.4096 7.66996 18.3359 7.52279 18.1331L4.5584 14.4646C4.45328 14.3355 4.49532 14.1512 4.64249 14.059C4.76863 13.9668 4.95785 13.9853 5.06297 14.0959L8.65809 17.322L7.90123 17.1192L12.6947 15.6444C12.968 15.5522 13.2413 15.6075 13.4726 15.7181L21 19.5C22 20 21.7194 22.0715 20.5 21.5L19.948 20.8614Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.1589 20L44.7308 22.3681C45.13 22.4253 45.0701 23.0365 44.6509 22.9983L29 22L29 19L30.1589 20Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5655 18.1883L24.7319 9.43251C24.7319 9.03794 25.3974 9.01915 25.439 9.39493L26.6453 18.0755C26.8116 19.3908 24.5655 19.5035 24.5655 18.1695V18.1883Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8137 22.7582L16.3253 24.4146C15.9301 24.5837 15.4631 24.1147 15.8374 23.9268L20.8778 21.086C22.1257 20.4283 23.1448 22.2321 21.8137 22.7582Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M25.8047 25.4248L20.9438 30.7271L21.0663 30.478L19.8001 34.7483C19.6979 35.1576 18.9423 35.033 19.0035 34.6238L19.6367 30.2467C19.6367 30.1399 19.6979 30.0688 19.7592 29.9976L24.1299 24.3928C24.9264 23.3964 26.6216 24.4995 25.7638 25.4426L25.8047 25.4248Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1585 18.5558L18.0422 13.4192C17.8486 13.1219 18.3712 12.8411 18.6035 13.1054L22.7844 17.6639C23.6167 18.6053 21.8166 19.5963 21.1585 18.5558Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M7.47014 42.1226C6.93871 42.1226 6.42904 42.3337 6.05326 42.7094C5.67748 43.0852 5.46637 43.5949 5.46637 44.1263V44.1263C5.55819 44.5831 5.80532 44.9941 6.1658 45.2893C6.52627 45.5845 6.97784 45.7458 7.44378 45.7458C7.90971 45.7458 8.36128 45.5845 8.72175 45.2893C9.08222 44.9941 9.32936 44.5831 9.42118 44.1263V44.1263C9.41805 43.6049 9.21311 43.105 8.84935 42.7314C8.4856 42.3578 7.99129 42.1396 7.47014 42.1226V42.1226Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M7.70739 24.0095C6.54791 23.965 5.40055 24.2592 4.40557 24.8561C3.41058 25.4531 2.61107 26.3271 2.10476 27.3711C1.95147 27.7996 1.96688 28.2704 2.14788 28.688C2.32888 29.1056 2.66191 29.4387 3.07944 29.6198C3.49697 29.8009 3.96775 29.8164 4.3963 29.6632C4.82486 29.51 5.17912 29.1996 5.38724 28.7949C5.60723 28.3819 5.93905 28.0393 6.34471 27.8061C6.75037 27.573 7.21348 27.4588 7.68103 27.4766C7.99264 27.4621 8.3039 27.5117 8.59557 27.6223C8.88724 27.7329 9.15312 27.9022 9.37677 28.1197C9.60041 28.3371 9.77706 28.5982 9.8958 28.8866C10.0145 29.1751 10.0728 29.4848 10.0671 29.7967C10.0671 31.115 9.21022 31.7214 8.2347 32.4333C7.40976 32.8812 6.72603 33.5503 6.2603 34.3653C5.79457 35.1803 5.56527 36.1091 5.59817 37.0472V37.2845C5.59817 37.788 5.79817 38.2708 6.15417 38.6268C6.51017 38.9828 6.99301 39.1828 7.49647 39.1828C7.99993 39.1828 8.48277 38.9828 8.83878 38.6268C9.19478 38.2708 9.39478 37.788 9.39478 37.2845V37.0472C9.39478 35.663 10.278 34.9907 11.2535 34.2261C12.0229 33.7758 12.6597 33.1302 13.0996 32.3547C13.5394 31.5793 13.7666 30.7014 13.7582 29.8099C13.7704 29.0234 13.6203 28.2428 13.3172 27.5169C13.0142 26.7911 12.5647 26.1355 11.9968 25.5911C11.429 25.0468 10.755 24.6254 10.0169 24.3533C9.27891 24.0812 8.49269 23.9641 7.70739 24.0095V24.0095Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgDamageNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamageNotFound);
export default __webpack_public_path__ + "static/media/damage-not-found.7e2fab794c4cc132424e22febf92a8bd.svg";
export { ForwardRef as ReactComponent };